/**
 * Defines sagas related to user entitled apps screen
 */
import { put, call } from 'redux-saga/effects';
import { fetchUserEntitledAppsService, updateUserOnboardStatusService } from 'services/App.service';
import {
  FETCH_USER_ENTITLED_APPS_SUCCESS, FETCH_USER_ENTITLED_APPS_ERROR,
  UPDATE_USER_ONBOARD_STATUS_ERROR,
} from 'constants/ActionTypes';

/** Map third-party API apps to legacy UI shape (appName, appURL, appLink). #genai */
export function mapThirdPartyAppsForUi(rawApps = []) {
  return rawApps.map((app) => ({
    ...app,
    appName: app.name,
    appURL: app.appUrl,
    appLink: (() => {
      try {
        return new URL(app.appUrl).hostname;
      } catch {
        return '';
      }
    })(),
  }));
}

// eslint-disable-next-line import/prefer-default-export
export function* fetchUserEntitledAppsSaga() {
  try {
    const response = yield call(fetchUserEntitledAppsService);
    if (!response.ok && response.json.errorCode !== 20016) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    const rawApps = response.ok ? response.json : [];
    const thirdPartyAppList = mapThirdPartyAppsForUi(rawApps);
    yield put({ type: FETCH_USER_ENTITLED_APPS_SUCCESS, thirdPartyAppList });
  } catch (error) {
    yield put({ type: FETCH_USER_ENTITLED_APPS_ERROR, error });
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* updateUserOnboardStatusSaga() {
  try {
    const response = yield call(updateUserOnboardStatusService);
    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
  } catch (error) {
    yield put({ type: UPDATE_USER_ONBOARD_STATUS_ERROR, error });
  }
}
